module.exports = "/assets/2b2d3e183fa0198134cdac993ee57981.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/FR.png
// module id = 2505
// module chunks = 0